module.exports = __webpack_public_path__ + "adc9d8c20afd9bbc1b4ca45880b582f4.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/critical-strike.mp4
// module id = 626
// module chunks = 0